const ContactDetailsItem = ({ icon, text, address = "", emirate = "", country = "" }) => {
    return (
        <div className="infodetatddivfllsxdlx">
            <div className="indfodetatildiv">
                <img src={icon} alt="icon" />
            </div>
            <p className="ingfddtertrrxrpp">{text || "N/A"}{address && <><br />{address}</>}{emirate && country && <><br />{emirate + ", " + country}</>}
            </p>
        </div>
    );
};
export default ContactDetailsItem;